import * as api from "../api";
import { ALERT, RESET_QUOTE, VAT } from "../constants/actionTypes";

import Prices from "../utils/prices";

export const createQuote = async (
  uploadQuote,
  setLoading,
  dispatch,
  history
) => {
  const subtotal = Math.ceil(
    Prices(
      uploadQuote.price,
      uploadQuote.totalCount,
      uploadQuote.languageTo.length,
      uploadQuote.urgent,
      uploadQuote.addson,
      0.11
    ).subtotal * 100
  );

  const total = Math.ceil(
    Prices(
      uploadQuote.price,
      uploadQuote.totalCount,
      uploadQuote.languageTo.length,
      uploadQuote.urgent,
      uploadQuote.addson,
      0.11
    ).total * 100
  );

  const vatValue = Math.ceil(
    Prices(
      uploadQuote.price,
      uploadQuote.totalCount,
      uploadQuote.languageTo.length,
      uploadQuote.urgent,
      uploadQuote.addson,
      0.11
    ).vat * 100
  );

  const uncountedFiles = uploadQuote.files.filter(
    (file) => file.count === 0
  ).length;

  const status = uncountedFiles > 0 ? "pending" : "inactive";
  const totalCount = uncountedFiles > 0 ? 0 : uploadQuote.totalCount;
  const user = JSON.parse(localStorage.getItem("auth"));
  const fileType = uploadQuote.files[0].name.substring(
    uploadQuote.files[0].name.lastIndexOf(".") + 1
  );

  const payment = {
    amount: uncountedFiles > 0 ? 0 : total,
    category: uploadQuote.category,
    totalCount: uploadQuote.totalCount,
    project: uploadQuote.projectName,
  };

  const filesSize = uploadQuote.files
    .map((file) => file.size)
    .reduce((acc, curr) => acc + curr, 0);
  if (filesSize > 12000000) {
    setLoading(false);
    return dispatch({
      type: ALERT,
      payload: {
        severity: "error",
        message: "Total files size exceed 12MB",
        duration: 5000,
        display: true,
      },
    });
  }

  if (user.role !== "basic") {
    setLoading(false);
    return dispatch({
      type: ALERT,
      payload: {
        severity: "error",
        message: `${user.role.toUpperCase()} can not create a project`,
        duration: 5000,
        display: true,
      },
    });
  }

  try {
    const { data } = await api.createQuote({
      ...uploadQuote,
      payment,
      status,
      totalCount,
      name: user.name,
      fileType,
    });

    if (uncountedFiles > 0) {
      await api.counter({ pending_projects: 1 });

      history.replace("/projects/index");

      dispatch({ type: RESET_QUOTE });
      dispatch({
        type: ALERT,
        payload: {
          severity: "Success",
          message:
            "Quote created succefully, payment link will be sent shortly",
          duration: 8000,
          display: true,
        },
      });
    } else {
      const invoice = {
        items: uploadQuote.files.map((file) => {
          return {
            item: file.name,
            description: uploadQuote.projectName,
            quantity: file.count,
            unitCost: uploadQuote.urgent
              ? uploadQuote.price + 0.11
              : uploadQuote.price,
          };
        }),
        type: "word",
        subtotal,
        total,
        vatValue,
        VAT: VAT,
        paid: 0,
        invoice_nr: data.quote_id,
        addson: uploadQuote.addson,
        langs: uploadQuote.languageTo.length,
      };

      await api.issueInvoice({
        email: user.email,
        invoice,
        id: data.id,
        paid: 0,
        quote_email: uploadQuote.email,
        projectName: uploadQuote.projectName,
      });

      history.replace(`/payment/${data.id}`);
      dispatch({
        type: ALERT,
        payload: {
          severity: "Success",
          message: "Quote created succefully, make payment to activate",
          duration: 8000,
          display: true,
        },
      });
    }
  } catch (error) {
    setLoading(false);
    if (error.response)
      dispatch({
        type: ALERT,
        payload: {
          severity: "error",
          message: error.response.data.message,
          duration: 5000,
          display: true,
        },
      });
    else
      dispatch({
        type: ALERT,
        payload: {
          severity: "error",
          message: "An unexpected error occurred",
          duration: 5000,
          display: true,
        },
      });
  }
};
